import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setBooking, setDelivery, setPickup, setStep } from "../../../Reducer/bookingSlice";
import Handler from "../../../Helpers/Components/Handler";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import TablePlaceHolder from "../../../Helpers/Components/TablePlaceHolder";
import moment from "moment";
import NextPrev from "../../../Helpers/Components/NextPrev";
import { toast } from "react-toastify";
import Select from 'react-select'

const Trip = (props) => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const booking = useSelector(state => state?.booking?.booking)
    const [carList, setCarList] = useState([])
    const getCarBooking = async () => {
        const response = await Handler({ method: 'post', url: `/booking/search`, data: { carId: booking?.car?.id, bookingId: props?.bookingId } })
        if (response?.success) {
            setCarList(response?.data)
        } else {
            setCarList([])
        }
    }
    const setSteps = () => {
        dispatch(setStep(0))
    }
    const handleNext = async () => {
        if (!booking?.deliveryDetails?.location) {
            toast.error("Delivery Location is required")
        } else if (!booking?.pickupDetails?.location) {
            toast.error("Pickup Location is required")
        } else if (!booking?.deliveryDetails?.delivery) {
            toast.error("Delivery Date is required")
        } else if (!booking?.pickupDetails?.pickup) {
            toast.error("Pickup Date is required")
        } else if (new Date(booking?.deliveryDetails?.delivery) > new Date(booking?.pickupDetails?.pickup)) {
            toast.error("Delivery date is less than Pickup date")
        } else if (!booking?.deliveryBy) {
            toast.error("Delivery by is required")
        } else {
            setLoading(true)
            const response = await Handler({ method: 'patch', data: { totalDays: (Number(booking?.totalDays || 0) + Number(booking?.point || 0)) || 0, carId: booking?.car?.id, deliveryBy: booking?.deliveryBy, deliveryDetails: { delivery: booking?.deliveryDetails?.delivery, location: booking?.deliveryDetails?.location }, pickupDetails: { pickup: booking?.pickupDetails?.pickup, location: booking?.pickupDetails?.location } }, url: `/booking/delivery/second/update/${props?.bookingId}` })
            if (response?.success) {
                dispatch(setStep(2))
            } else {
                toast.error(response?.message)
            }
            setLoading(false)
        }
    }
    useEffect(() => {
        if (booking?.deliveryDetails?.delivery && booking?.pickupDetails?.pickup) {
            let diff = ((new Date(booking?.pickupDetails?.pickup).getTime() - new Date(booking?.deliveryDetails?.delivery).getTime()) / 1000) / 3600;
            if (Math.ceil(diff / 12) / 2 == 0.5) {
                dispatch(setBooking({ totalDays: 1, point: 0, halfDayOffer: 0 }))
            } else {
                dispatch(setBooking({ totalDays: Math.floor(Math.ceil(diff / 12) / 2) }));
                if (Math.ceil(diff / 12) % 2 !== 0) {
                    let to = new Date(booking?.pickupDetails?.pickup)
                    to?.setHours(new Date(booking?.pickupDetails?.pickup)?.getHours() - 2)
                    let diff1 = ((to?.getTime() - new Date(booking?.deliveryDetails?.delivery).getTime()) / 1000) / 3600
                    if (Math.ceil(diff1 / 12) % 2 !== 0) {
                        dispatch(setBooking({ point: 0.5 }))
                    } else {
                        dispatch(setBooking({ point: 0, halfDayOffer: 0 }))
                    }
                } else {
                    dispatch(setBooking({ point: 0, halfDayOffer: 0 }))
                }
            }
        }
    }, [booking?.deliveryDetails?.delivery, booking?.pickupDetails?.pickup])
    useEffect(() => {
        if (booking?.car?.id) {
            getCarBooking()
        }
    }, [booking?.car?.id])

    return (
        <React.Fragment>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="carId" className="form-label"> Car ID </label>
                        <input name="carId" id="carId" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.car?.carId || ""} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    {
                        booking?.car?.id ?
                            <div className="mb-3">
                                <div className="text-capitalize">Model: {(booking?.car?.model || "")}</div>
                                <div className="text-capitalize">Color: {(booking?.car?.color || "-")}</div>
                                <div className="text-upper">Reg No: {(booking?.car?.registrationNo || "-")}</div>
                                <div className="text-capitalize">Fastag Bank: {(booking?.car?.fasTagType || "-")}</div>
                            </div>
                            : ""
                    }
                </div>
            </div>
            {
                booking?.car?.id ?
                    <>
                        <div className="row mt-3">
                            <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                                <div className="mb-3">
                                    <label htmlFor="location" className="form-label"> Delivery Location </label>
                                    <input onChange={(e) => dispatch(setDelivery({ location: e.target.value }))} name="location" id="location" autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" value={booking?.deliveryDetails?.location || ""} />
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                                <div className="mb-3">
                                    <label htmlFor="pickupLocation" className="form-label"> Pickup Location </label>
                                    <input onChange={(e) => dispatch(setPickup({ location: e.target.value }))} name="pickupLocation" id="pickupLocation" autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" value={booking?.pickupDetails?.location || ""} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                                <div className="mb-3">
                                    <label htmlFor="pickup" className="form-label"> Delivery Date and Time </label>
                                    <div className=" datepicker-top">
                                        <DatePicker
                                            className="input-theme"
                                            value={booking?.deliveryDetails?.delivery ? new Date(booking?.deliveryDetails?.delivery) : ""}
                                            onChange={(e) => {
                                                const date = new Date(e);
                                                const minutes = date.getMinutes();
                                                const roundedMinutes = Math.ceil(minutes / 5) * 5;
                                                date.setMinutes(roundedMinutes);
                                                date.setSeconds(0);
                                                date.setMilliseconds(0);
                                                dispatch(setDelivery({ delivery: date?.toString() })); if (!booking?.pickupDetails?.pickup) { dispatch(setPickup({ pickup: new Date(date?.setDate(date?.getDate() + 1))?.toString() })) }
                                            }}
                                            format="DD-MM-YYYY hh:mm A"
                                            plugins={[
                                                <TimePicker position="bottom" hideSeconds mStep={5} />,
                                            ]}
                                            disabled={loading}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                                <div className="mb-3">
                                    <label htmlFor="lastName" className="form-label"> Pickup Date and Time </label>
                                    <div className=" datepicker-top">
                                        <DatePicker
                                            className="input-theme"
                                            value={booking?.pickupDetails?.pickup ? new Date(booking?.pickupDetails?.pickup) : new Date(new Date(booking?.deliveryDetails?.delivery)?.setDate(new Date(booking?.deliveryDetails?.delivery)?.getDate() + 1))}
                                            onChange={(e) => {
                                                const date = new Date(e);
                                                const minutes = date.getMinutes();
                                                const roundedMinutes = Math.ceil(minutes / 5) * 5;
                                                date.setMinutes(roundedMinutes);
                                                date.setSeconds(0);
                                                date.setMilliseconds(0);
                                                dispatch(setPickup({ pickup: date?.toString() }))
                                            }}
                                            format="DD-MM-YYYY hh:mm A"
                                            plugins={[
                                                <TimePicker position="bottom" hideSeconds mStep={5} />
                                            ]}
                                            minDate={booking?.deliveryDetails?.delivery ? new Date(booking?.deliveryDetails?.delivery) : new Date()}
                                            disabled={loading || !booking?.deliveryDetails?.delivery}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                                <div className="mb-3">
                                    <label htmlFor="bookBy" className="form-label">Booking Given By </label>
                                    <Select
                                        styles={{
                                            control: (base, state) => ({
                                                ...base,
                                                borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                                boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                                "&:hover": {
                                                    borderColor: "#f16436"
                                                }
                                            }),
                                            option: (style, state) => ({
                                                ...style,
                                                backgroundColor: state.isSelected
                                                    ? "#f16436"
                                                    : (state.isFocused || state.isActive)
                                                        ? "#f164361a"
                                                        : "white",
                                                color: state.isSelected ? "white" : "black"
                                            })
                                        }}
                                        onChange={(e) => { dispatch(setBooking({ deliveryBy: e.value })) }} value={props?.leadList?.length && booking.deliveryBy ? (props?.leadList?.find(element => element.value === booking?.deliveryBy) || "") : ""} options={props.leadList} />
                                </div>
                            </div>
                        </div>

                        <div className="overflow mt-3">
                            <table className="table-bg table" borderless="true">
                                <thead>
                                    <tr>
                                        <th className="text-center rounded-start">S. No </th>
                                        <th>Booking ID </th>
                                        <th>Delivery Date </th>
                                        <th>Pickup Date </th>
                                        <th>Status </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        loading ? <TablePlaceHolder count={5} /> :
                                            (carList?.length ? carList?.map((element, i) => {
                                                return (
                                                    <tr key={i} id={i} className="align-middle">
                                                        <td className="text-center">{(i + 1)}</td>
                                                        <td>{element?.bookingId}</td>
                                                        <td>{element?.deliveryDetails?.delivery ? moment(element?.deliveryDetails?.delivery)?.format("DD-MM-YYYY hh:mm A") : ""}</td>
                                                        <td>{element?.pickupDetails?.pickup ? moment(element?.pickupDetails?.pickup)?.format("DD-MM-YYYY hh:mm A") : ""}</td>
                                                        <td>{element?.status}</td>
                                                    </tr>
                                                )
                                            }) : <tr><td colSpan={5} className="text-center">No Data Found</td></tr>)
                                    }
                                </tbody>
                            </table>
                        </div>
                    </>
                    : ""
            }
            <NextPrev step={1} setStep={setSteps} last={3} onClick={handleNext} loading={loading} />
        </React.Fragment>
    )
}

export default Trip;